import { Component } from 'react';
const defaultProps = {
    fallback: null,
    children: null
};
class ErrorBoundary extends Component {
    // eslint-disable-next-line react/static-property-placement
    static defaultProps;
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    static getDerivedStateFromError(_) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }
    componentDidCatch(error, errorInfo) {
        console.error('Uncaught error:', error, errorInfo);
    }
    render() {
        const { hasError } = this.state;
        const { fallback = null, children = null } = this.props;
        if (hasError && fallback)
            return fallback;
        return children;
    }
}
ErrorBoundary.defaultProps = defaultProps;
export default ErrorBoundary;
